import EntityType from "@mapmycustomers/shared/enum/EntityType";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import { EntityPin } from "@mapmycustomers/shared/types/map";

import { mapEntityIdGetter, mapPinIdGetter } from "@app/util/map/idGetters";
import { StopVisualsMap } from "@app/util/map/markerStyles/types/StopVisual";

export type StopVisualSeed = Identified & { entity: EntityType };

// Optimistic fill for newly added stops: the authoritative colors arrive with the /pins
// visuals refetch, so until it lands a new stop would flash in the default color. The
// pin the stop came from usually already carries the same legend-computed color/shape —
// copy it in. Existing keys are kept so seeds never clobber fetched values.
const seedStopVisuals = (
  stopVisuals: StopVisualsMap,
  entityPins: EntityPin[],
  stops: StopVisualSeed[]
): StopVisualsMap => {
  const missing = stops.filter(
    (stop) =>
      (stop.entity === EntityType.COMPANY || stop.entity === EntityType.PERSON) &&
      !(mapEntityIdGetter(stop) in stopVisuals)
  );
  if (!missing.length) {
    return stopVisuals;
  }

  const pinsByKey = new Map(entityPins.map((pin) => [mapPinIdGetter(pin), pin]));
  let result = stopVisuals;
  missing.forEach((stop) => {
    const pin = pinsByKey.get(mapEntityIdGetter(stop));
    if (!pin) {
      return;
    }
    if (result === stopVisuals) {
      result = { ...stopVisuals };
    }
    result[mapEntityIdGetter(stop)] = { color: pin.data.color, shape: pin.data.shape };
  });
  return result;
};

export default seedStopVisuals;
